import { Button, IconButton } from "@mui/material";
import './ThankYou.css'
import { useNavigate } from "react-router-dom";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import HomeIcon from "@mui/icons-material/Home";
import LinkIcon from '@mui/icons-material/Link';
import { addZerosToScore } from "../../utills";


const ThankYou = ({score}) => {
  const navigate = useNavigate();
  const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
  };
  const navigteToGame = () => {
    navigate("/game");
  };

const copyToClipboard = async ()=>{
  const message = 'איזה כיף' +'!'+'\n' +'השגתי תוצאה של'+' '+ score + ' '+ 'במשחק החדש של כיף'+ '.'+'\n'+ 'https://catch-the-keff.web.app/'
  await navigator.clipboard.writeText(  message   );
    alert('קישור למשחק הועתק');
}



  return (
    <div className="background">

      <div className="block"></div>
    <div className="thank-you-container">
      <div className="thank-you-inner-container">
        <p className="the-best-text">אתם מעולים!</p>
      <div className="score-box">
          <div className="second-section">
            <p className="score">{ addZerosToScore(score)}</p>
          </div>
          <div className="first-section">
            <p className="score-text">הניקוד שלכם</p>
          </div>
        </div>
        <div>

        <p className="the-best-first"> אנחנו בטוחים שאתם יכולים להיות</p>
        <p className="the-best-text">הטובים ביותר</p>
        </div>
        <Button className="thank-you-bt" size="small" variant="contained" onClick={navigteToGame}>
          <span className="play-again-text">שחקו שוב</span>
        </Button>
        <div className="socials">
          <IconButton
            role="link"
            onClick={() => openInNewTab("https://www.instagram.com/keff_il/")}
          >
            <InstagramIcon />
          </IconButton>
          <IconButton
            role="link"
            onClick={() => openInNewTab("https://www.facebook.com/Muy.Keff/")}
          >
            <FacebookIcon />
          </IconButton>
          <IconButton
            role="link"
            onClick={ copyToClipboard}
          >
            <LinkIcon />
          </IconButton>
          <IconButton
            role="link"
            onClick={() => openInNewTab("https://keff.co.il/")}
          >
            <HomeIcon />
          </IconButton>
        </div>
      </div>
    </div>
    </div>
  );
};

export default ThankYou;
